// extracted by mini-css-extract-plugin
export default {"review_header":"Header_review_header__1TPRv","header_button":"Header_header_button__1XCut","header_text":"Header_header_text__Ngi1u"};